import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckmarkPulsereact = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 104,
	height: 104,
	viewBox: "0 0 104 104",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M52 104C80.7188 104 104 80.7188 104 52C104 23.2812 80.7188 0 52 0C23.2812 0 0 23.2812 0 52C0 80.7188 23.2812 104 52 104Z",
			fill: "#08CAA7"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M52.0004 90.6976C73.3726 90.6976 90.6981 73.3721 90.6981 52C90.6981 30.6278 73.3726 13.3023 52.0004 13.3023C30.6283 13.3023 13.3027 30.6278 13.3027 52C13.3027 73.3721 30.6283 90.6976 52.0004 90.6976Z",
			fill: "#08CAA7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67.7895 37L45.6842 57.7143L36.2105 48.3929L32 52.5357L45.6842 66L72 41.1429L67.7895 37Z",
			fill: "white"
		})
	]
});
export default SvgCheckmarkPulsereact;
